"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ColorBox_1 = __importDefault(require("./ColorBox"));
var styles_1 = require("./styles");
var colors_1 = require("./colors");
var TannerGraysColorsComponent = function () {
    var mapColorEntries = function (colorName, colorObject) {
        var _a;
        return (_a = Object === null || Object === void 0 ? void 0 : Object.keys(colorObject)) === null || _a === void 0 ? void 0 : _a.map(function (key) { return ({
            label: "".concat(colorName, "/").concat(key),
            color: colorObject[key],
        }); });
    };
    var tannerGrayColors = __spreadArray([], __read(mapColorEntries('TannerGray', colors_1.tannerGray)), false);
    tannerGrayColors.splice(12, 2); //removed color and background and added to largeTannerGrayColors for ordering
    var largeTannerGrayColors = [
        { label: 'TannerGray/Black', color: colors_1.tannerBlack },
        { label: 'TannerGray/White', color: colors_1.tannerWhite },
        { label: 'TannerGray/background', color: colors_1.tannerGray.background },
        { label: 'TannerGray/color', color: colors_1.tannerGray.color },
    ];
    return (react_1.default.createElement(styles_1.RootBox, null,
        react_1.default.createElement(styles_1.TitleTypography, { variant: "h3" }, "Grays"),
        react_1.default.createElement(styles_1.GridBox, null, tannerGrayColors === null || tannerGrayColors === void 0 ? void 0 :
            tannerGrayColors.map(function (_a) {
                var color = _a.color, label = _a.label;
                return (react_1.default.createElement(ColorBox_1.default, { key: color, color: color, label: label }));
            }), largeTannerGrayColors === null || largeTannerGrayColors === void 0 ? void 0 :
            largeTannerGrayColors.map(function (_a) {
                var color = _a.color, label = _a.label;
                return (react_1.default.createElement(ColorBox_1.default, { key: color, color: color, label: label }));
            }))));
};
exports.default = TannerGraysColorsComponent;
//# sourceMappingURL=TannerGraysColorsComponent.js.map